import { CommonErrorStatus } from '@/constants/error/commonErrorStatus';

export enum FrontPopupErrorStatus {
  SVC_LOGO_EXCEEDED_FILE_SIZE = CommonErrorStatus.SVC_LOGO_EXCEEDED_FILE_SIZE,
  SVC_LOGO_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.SVC_LOGO_NOT_ALLOWED_FILE_FORMAT,
  CI_DOC_EXCEEDED_FILE_COUNT = CommonErrorStatus.CI_DOC_EXCEEDED_FILE_COUNT,
  CI_DOC_EXCEEDED_FILE_SIZE = CommonErrorStatus.CI_DOC_EXCEEDED_FILE_SIZE,
  CI_DOC_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.CI_DOC_NOT_ALLOWED_FILE_FORMAT,
  CI_DOC_FILE_REQUIRED = CommonErrorStatus.CI_DOC_FILE_REQUIRED,
  APP_ICON_EXCEEDED_FILE_SIZE = CommonErrorStatus.APP_ICON_EXCEEDED_FILE_SIZE,
  APP_ICON_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.APP_ICON_NOT_ALLOWED_FILE_FORMAT,
  ALIM_TALK_IMAGE_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.ALIM_TALK_IMAGE_NOT_ALLOWED_FILE_FORMAT,
  ALIM_TALK_IMAGE_EXCEEDED_FILE_SIZE = CommonErrorStatus.ALIM_TALK_IMAGE_EXCEEDED_FILE_SIZE,
  SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_COUNT = CommonErrorStatus.SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_COUNT,
  SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_SIZE = CommonErrorStatus.SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_SIZE,
  SETTLE_ADJUST_REQUEST_NOT_ALLOWED_FILE_FORMAT = CommonErrorStatus.SETTLE_ADJUST_REQUEST_NOT_ALLOWED_FILE_FORMAT,

  /* 프론트용 오류 코드는 양수 500 + 서버 카테고리 코드로 정의 */
  // 00: 공통
  INVALID_EMAIL = 5000001, // 이메일 형식 오류
  DUPLICATED_EMAIL = 5000002, // 중복된 이메일
  // 01: 인증/인가/권한
  INVITED_ACCOUNT_NOT_MATCHED = 5000100, // 초대된 계정과 로그인한 계정이 일치하지 않음
  // 03: 사업자
  BUSINESS_NUMBER_NOT_VALIDATED = 5000300, // 사업자 등록번호 검증 전
  INVALID_BUSINESS_NUMBER = 5000301, // 사업자 등록번호 형식 오류
  // 05: 파트너
  MANAGER_EMAIL_NOT_VALIDATED = 5000500, // 이용기관 관리자 이메일 주소 검증 전
  // 06: 서비스
  SVC_NAME_NOT_VALIDATED = 5000600, // 기관명 검증 전
  PARTNER_CHANNEL_URL_NOT_VALIDATED = 5000601, // 이용기관 채널 URL 검증 전
  PARTNER_CHANNEL_UUID_REQUIRED = 5000603, // 알림톡 이미지는 있지만, 이용기관 채널 UUID 검증을 하지 않은 경우

  // 10: 앱
  CHANNEL_URL_NOT_VALIDATED = 5001000 // 앱등록 채널 URL 검증 전
}
